import { useTranslation } from "react-i18next";
import { useLanguage } from "units/dashboard/context/LanguageProvider";
import StatBox from "./StatBox";

export default function StatsBand() {
  const { t } = useTranslation("landing");
  const { lang } = useLanguage();

  const percentSuffix = lang === "en" ? "%" : "٪";
  const plusSuffix = "+";

  const STATS = [
    {
      to: 2500,
      suffix: plusSuffix,
      label: t("stats.businesses"),
    },
    {
      to: 98,
      suffix: percentSuffix,
      label: t("stats.satisfaction"),
    },
    {
      to: 12,
      suffix: "M+",
      suffixFa: "M+",
      suffixAr: "M+",
      label: t("stats.monthly"),
    },
    {
      to: 0.3,
      decimals: 1,
      suffix: "s",
      suffixFa: "s",
      suffixAr: "s",
      label: t("stats.avgResp"),
    },
  ];

  return (
    <section className="py-10 sm:!py-12 lg:!py-16">
      <div className="mx-auto max-w-container px-5 sm:!px-7">
        {/* گرادیان کارت اصلی */}
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-teal via-teal-700 to-[#052f2b] px-6 py-12 shadow-card-lg sm:!rounded-[36px] sm:!px-10 sm:!py-16 lg:!px-16 lg:!py-20">
          {/* Glow ۱ — طلایی بالا چپ */}
          <div
            aria-hidden
            className="pointer-events-none absolute -top-32 -start-32 h-[380px] w-[380px] animate-pulse rounded-full bg-gold-2/40 blur-[100px]"
            style={{ animationDuration: "8s" }}
          />
          {/* Glow ۲ — تیل کم‌رنگ پایین راست */}
          <div
            aria-hidden
            className="pointer-events-none absolute -bottom-40 -end-40 h-[420px] w-[420px] animate-pulse rounded-full bg-teal-3/30 blur-[100px]"
            style={{ animationDuration: "10s", animationDelay: "3s" }}
          />

          {/* Grid */}
          <div className="relative z-10 grid grid-cols-2 gap-x-4 gap-y-10 sm:!gap-x-8 lg:!grid-cols-4 lg:!gap-x-6">
            {STATS.map((stat, i) => (
              <StatBox
                key={i}
                to={stat.to}
                decimals={stat.decimals}
                suffix={stat.suffix}
                suffixEn={stat.suffix}
                suffixAr={stat.suffixAr || stat.suffix}
                label={stat.label}
                index={i}
              />
            ))}
          </div>

          {/* Decorative dot pattern */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage: `radial-gradient(circle, white 1px, transparent 1px)`,
              backgroundSize: "24px 24px",
            }}
          />
        </div>
      </div>
    </section>
  );
}